<template>
    <div>
        <div class="form-single">
            <div class="input-tip error" v-if="readOnly == null || !readOnly">提示:最多上传5个附件，上传附件大小不可超过5M</div>
            <div class="form-value">
                <swb-file-upload v-if="readOnly == null || !readOnly" fileGroup="image-goods" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="false"></swb-file-upload>
                <ul class="file-area input clearfix" v-if="shopDeviceTransFileList.length > 0">
                    <li class="file-content clearfix" v-for="(file, index) in shopDeviceTransFileList">
                        <swb-file-item :trackKey="index" :fileName="file.name" :fileUuid="file.fileUuid" :fileBrowseUrl="file.fileBrowseUrl" :fileDownloadUrl="file.fileDownLoadUrl" :fileMd5="file.fileMd5" :deletable="readOnly == null || !readOnly" :onDelete="deleteFile"></swb-file-item>
                        <el-input :disabled="file.id != null" v-model="file.desc" placeholder="请输入内容"></el-input>
                    </li>
                </ul>

            </div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import assetVchrApi from '../../api/assetVchr';
    //
    import SwbFileUpload from '../ctrl/FileUpload';
    Vue.regist(SwbFileUpload);
    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);

    export default {
        name: 'swb-shop-device-trans-img-edit',
        desc: '调拨上传',
        props: ['id', 'readOnly'],
        data: function () {

            return {
                // 资产图片
                shopDeviceTransFileList: [],
            }
        },
        created: function () {
            this.getShopDeviceTransFileListByVoucherId();
        },
        methods: {
            getShopDeviceTransFileListByVoucherId: function () {
                let self = this;
                let postData = {};
                postData.voucherId = self.id;
                assetVchrApi.getShopDeviceTransFileListByVoucherId(postData, function (result) {
                    if(result.type == "info") {
                        self.shopDeviceTransFileList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                let shopDeviceTransFileList = this.shopDeviceTransFileList || [];
                if(shopDeviceTransFileList.length > 4) {
                    MsgBox.warning("最多上传5张附件");
                    return false;
                }
                if(fileItems.length === 0) {
                    MsgBox.warning('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            //上传进度处理
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            changedesc: function () {
                let self = this;
                let shopDeviceTransFileList = self.shopDeviceTransFileList;
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                let self = this;
                let shopDeviceTransFileList = self.shopDeviceTransFileList || [];
                if(shopDeviceTransFileList.length > 4) {
                    MsgBox.warning("最多上传5张附件");
                    return false;
                }
                if(result.type === 'info') {
                    let files = result.data.files || [];
                    let file = files[0];
                    let shopDeviceTransFile = {};
                    shopDeviceTransFile.name = file.fileName;
                    shopDeviceTransFile.fileUuid = file.fileUuid;
                    shopDeviceTransFile.fileExtName = file.fileExtName;
                    shopDeviceTransFile.fileBrowseUrl = file.fileBrowseUrl;
                    shopDeviceTransFile.fileDownLoadUrl = file.fileDownloadUrl;
                    shopDeviceTransFile.fileMd5 = file.fileMd5;
                    shopDeviceTransFile.desc = null;
                    shopDeviceTransFileList.push(shopDeviceTransFile);
                    self.shopDeviceTransFileList = Utils.merge([], shopDeviceTransFileList);
                } else {
                    MsgBox.warning(result.message);
                }
            },
            deleteFile: function (index) {
                this.shopDeviceTransFileList.removeAt(index.trackKey);
                return false;
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                let shopDeviceTransFileList = self.shopDeviceTransFileList || [];
                result.data = shopDeviceTransFileList;
                result.type = "info";
                return result;
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/transVoucher/ShopDeviceTransFileList.vue